<section class="faq" [attr.aria-labelledby]="headingId">
    <h2 *ngIf="resolvedHeading" [id]="headingId" class="faq-title">{{ resolvedHeading }}</h2>
  
    <div class="faq-list" *ngIf="resolved_items?.length; else empty">
      <details
        *ngFor="let item of resolved_items; let i = index"
        class="faq-item"
        [attr.id]="anchorFor(i, item)"
        [attr.open]="isOpen(i, item) ? true : null"
      >
        <summary class="faq-q">
          <span class="q-text">{{ item.question }}</span>
        </summary>
  
        <div class="faq-a" [innerHTML]="item.answer"></div>
      </details>
    </div>
  
    <ng-template #empty>
      <p class="empty">No FAQs available.</p>
    </ng-template>
  </section>
  
